<template>
	<div class="content background1" style="display: flex">
		<div class="tableBox9" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<el-tab-pane :label="$t('label_429')" name="first">
							<template v-if="treeShow">
								<tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes" @getDeviceMes2="getDeviceMes2" ref="treeDisplay"></tree>
							</template>
						</el-tab-pane>
						<el-tab-pane :label="$t('label_161')" name="second">
							<template v-if="treeShow">
								<tree :dataTree="treeData2" :treeType="1" :pink="1" @getDeviceMes="getDeviceMes" @getDeviceMes2="getDeviceMes2"
								 @jump="jump" ref="treeDisplay2"></tree>
							</template>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes" v-if="getTreeMes=='0'">
						<p class="title">{{deviceDetailMes.name}}</p>
						<div class="chooseBox" style="height: 80px">
							<div class="selectBox">
								<div>
									<div class="selectChooseStatus" style="width: 17vw">
										<div class="selectText">
											<p>{{$t('label_387')}}</p>
										</div>
										<div class="select">
											<div class="showbox">
												<div class="show" style="background: #c1c1c1">
													<div class="name">{{$t('btn_22')}}</div>
													<p>{{equipmentStatusList.useCheck}}</p>
												</div>
												<div class="show" style="background: #3fb393">
													<div class="name">{{$t('label_105')}}</div>
													<p>{{equipmentStatusList.useNormal}}</p>
												</div>
												<div class="show" style="background: #ff0000">
													<div class="name">{{$t('btn_21')}}</div>
													<p>{{equipmentStatusList.useScrap}}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChooseStatus">
										<div class="selectText">
											<p>{{$t('label_391')}}</p>
										</div>
										<div class="select">
											<div class="showbox">
												<div class="show" style="background: #3fb393">
													<div class="name">{{$t('btn_23')}}</div>
													<p>{{equipmentStatusList.operationOpen}}</p>
												</div>
												<div class="show" style="background: #ff0000">
													<div class="name">{{$t('btn_24')}}</div>
													<p>{{equipmentStatusList.operationOut}}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChooseStatus">
										<div class="selectText">
											<p>{{$t('label_394')}}</p>
										</div>
										<div class="select">
											<div class="showbox">
												<div class="show" style="background: #3fb393">
													<div class="name">{{$t('label_105')}}</div>
													<p>{{equipmentStatusList.failureNormal}}</p>
												</div>
												<div class="show" style="background: #ff0000">
													<div class="name">{{$t('label_408')}}</div>
													<p>{{equipmentStatusList.failureAlarm}}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChooseStatus" style="width: 18vw">
										<div class="selectText">
											<p>{{$t('label_397')}}</p>
										</div>
										<div class="select">
											<div class="showbox">
												<div class="show" style="background: #3fb393">
													<div class="name">{{$t('label_105')}}</div>
													<p>{{equipmentStatusList.lifeNormal}}</p>
												</div>
												<div class="show" style="background: #ffb400">
													<div class="name">{{$t('label_411')}}</div>
													<p>{{equipmentStatusList.lifeCare}}</p>
												</div>
												<div class="show" style="background: #c1c1c1">
													<div class="name">{{$t('label_286')}}</div>
													<p>{{equipmentStatusList.lifeAlarm}}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="spotMes2Box">
							<div class="tabBbox">
								<div class="buttonBox" style="margin-left: 10px;">
									<div>
										<div class="chooseButton searchButton" @click="exportExcel">{{$t('btn_68')}}</div>
									</div>
									<div style="margin-left: 10px;">
										<el-upload class="upload-demo" style="width: 100%;" action="/" :show-file-list="false" :http-request="importExcel">
											<div class="chooseButton searchButton">
												{{$t('btn_9')}}
											</div>
										</el-upload>
									</div>
								</div>
							</div>
							<div class="tableMin2">
								<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataDeviceList" highlight-current-row @current-change="handleCurrentChangeTreeTime"
								 border style="width: 100%;margin: 10px" height="100%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
									<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
									</el-table-column>
									<el-table-column prop="name" :label="$t('label_1')" align="center" width="200">
										<template slot-scope="scope">
											<p class="tableMiTitle" @click="showDeviceMes(scope.row)">
												{{version==1?scope.row.code:scope.row.name}}<br>
											</p>
										</template>
									</el-table-column>
									<el-table-column prop="useTime" :label="$t('label_181')" align="center">
										<template slot-scope="scope">
											{{scope.row.useTime}}{{$t('label_534')}}
										</template>
									</el-table-column>
									<el-table-column prop="lifeState" :label="$t('label_397')" align="center">
										<template slot-scope="scope">
											<p :style="{color:(scope.row.lifeState=='1'?'green':scope.row.lifeState=='2'?'#ffaa00':'red')}">{{scope.row.lifeState=='1'?$t('label_105'):scope.row.lifeState=='2'?$t('label_411'):$t('label_286')}}</p>
										</template>
									</el-table-column>
									<el-table-column prop="superior" :label="$t('label_414')" align="center">
									</el-table-column>
									<el-table-column prop="useState" :label="$t('label_387')" align="center">
										<template slot-scope="scope">
											<p :style="{color:(scope.row.useState=='1'?'gray':scope.row.useState=='3'?'red':'green')}">{{scope.row.useState=='1'?$t('btn_22'):scope.row.useState=='3'?$t('btn_21'):$t('label_105')}}</p>
										</template>
									</el-table-column>
									<el-table-column prop="operationState" :label="$t('label_391')" align="center">
										<template slot-scope="scope">
											<p :style="{color:(scope.row.operationState=='1'?'green':'red')}">{{scope.row.operationState=='2'?$t('btn_24'):$t('btn_23')}}</p>
										</template>
									</el-table-column>
									<el-table-column prop="failureState" :label="$t('label_394')" align="center">
										<template slot-scope="scope">
											<p :style="{color:(scope.row.failureState=='1'?'green':'red')}">{{scope.row.failureState=='1'?$t('label_105'):$t('label_408')}}</p>
										</template>
									</el-table-column>
								</el-table>
								<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
								 @parentMethod="searchPage"></Page>
							</div>
						</div>
					</div>
					<div class="treeMes" v-if="getTreeMes=='3'">
						<p class="title"><span class="spot">{{deviceDetailMes.name}}</span></p>
						<div class="buttonBox" style="justify-content: right;position:absolute;top: 15px;right: 15px">
							<div class="chooseButton deleteButton" @click="baoFei">{{$t('btn_21')}}</div>
							<div class="chooseButton sendButton" style="background: #30bc85" @click="baocun"><i class="el-icon-receiving"></i>{{$t('btn_13')}}</div>
							<!-- <div class="chooseButton sendButton" @click="confrim"><i class="el-icon-s-claim"></i>确认</div> -->
						</div>
						<div class="chooseBoxDevice" style="height: 280px;margin-top: 20px">
							<div class="devicePic">
								<div class="pic" style="position:relative;">
									<el-upload class="upload-demo" action="https://jsonplaceholder.typ icode.com/posts/" :show-file-list="false"
									 :http-request="upload">
										<i class="el-icon-picture-outline" v-if="!cardData.img"></i>
										<img style="width: 150px;height: 150px;position:absolute;left: 0;top: 0" v-if="cardData.img" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+cardData.img">
									</el-upload>
								</div>
								<!-- <p>{{$t('label_450')}}</p>
								<p>
									<el-radio v-model="cardData.autoFlag" label="1">{{$t('label_454')}}</el-radio>
									<el-radio v-model="cardData.autoFlag" label="0">{{$t('label_458')}}</el-radio>
								</p> -->

							</div>
							<div class="selectBox" style="dispaly:gird"><!--v-if="version==1"-->
								<div class="selectChoose">
									<div class="selectText">
										<p>{{$t('label_593')}}</p>
									</div>
									<div class="select">
										<el-input v-model="cardData.equipmentName" maxlength="50" :placeholder="$t('input_60')"></el-input>
									</div>
								</div>

                <div class="selectChoose">
                  <div class="selectText">
                    <p>{{$t('label_429')}}</p>
                  </div>
                  <div class="select">
                    <!-- <el-input v-model="cardData.equipmentTypeName"></el-input> -->
                    <el-autocomplete v-model="cardData.equipmentTypeName" :fetch-suggestions="queryTypeName" :placeholder="$t('input_65')"
                                     @select="handleSelectType" value-key="name"></el-autocomplete>

                  </div>
                </div>
								<div class="selectChoose">
									<div class="selectText">
										<p>{{$t('label_439')}}</p>
									</div>
									<div class="select">
										<el-date-picker type="date" value-format='yyyy-MM-dd' v-model="cardData.buyTime" :placeholder="$t('input_91')"></el-date-picker>
									</div>
								</div>
								<div class="selectChoose">
									<div class="selectText">
										<p>{{$t('label_672')}}</p>
									</div>
									<div class="select">
										<!-- <el-input v-model="cardData.maker"></el-input> -->
										<el-autocomplete v-model="cardData.maker" :fetch-suggestions="querySearchAsyncMaker" :placeholder="$t('input_61')"
										 @select="handleSelectMaker" value-key="name"></el-autocomplete>
									</div>
								</div>
								<div class="selectChoose">
									<div class="selectText">
										<p>{{$t('label_488')}}</p>
									</div>
									<div class="select">
										<el-input v-model="cardData.deviceAddress" maxlength="50" @input="handleInput" :placeholder="$t('label_488')"></el-input>
									</div>
								</div>
							</div>
							<div class="selectBox" style="dispaly:gird"><!--v-if="version==1"-->
								<div class="selectChoose">
									<div class="selectText">
										<p>{{$t('label_194')}}</p>
									</div>
									<div class="select">
										<el-input v-model="cardData.equipmentCode" maxlength="50" :placeholder="$t('input_54')"></el-input>
									</div>
								</div>

                <div class="selectChoose">
                  <div class="selectText">
                    <p>{{$t('label_161')}}</p>
                  </div>
                  <div class="select">
                    <!-- <el-input v-model="cardData.deptName"></el-input> -->
                    <!-- <el-autocomplete v-model="cardData.deptName" :fetch-suggestions="queryDeptName" :placeholder="请选择所属区域" @select="handleSelectDept"
                     value-key="name"></el-autocomplete> -->
                    <el-tooltip class="item" effect="dark" :content="cardData.deptName" placement="top-start">
                      <el-select :value="cardData.deptName" clearable :placeholder="$t('input_65')" ref="selectTree1" :clearable="false">
                        <el-option :value="cardData.deptName" style="height: auto">
                          <el-tree :load="loadTree" @check-change="treeCheck" ref="tree" show-checkbox check-strictly lazy :props="treeProps"
                                   :accordion='true' node-key="id" :default-expanded-keys="deptIdList">
                            <div class="custom-tree-node" slot-scope="{node,data}">
                              <div class="title" style="width:250px;position:relative;display: flex">
                                <p style="width: 150px;display: block;overflow: hidden;line-height: 30px;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;">
                                  {{data.name}}
                                </p>
                              </div>
                            </div>
                          </el-tree>
                        </el-option>
                      </el-select>
                    </el-tooltip>
                  </div>
                </div>
								<div class="selectChoose">
									<div class="selectText">
										<p>{{$t('label_481')}}</p>
									</div>
									<div class="select">
										<!-- <el-input v-model="cardData.startUseTime"></el-input> -->
										<el-date-picker type="date" value-format='yyyy-MM-dd' v-model="cardData.startUseTime" :placeholder="$t('input_91')"></el-date-picker>
									</div>
								</div>
								<div class="selectChoose">
									<div class="selectText">
										<p>{{$t('label_432')}}</p>
									</div>
									<div class="select">
										<!-- <el-input v-model="cardData.saler"></el-input> -->
										<el-autocomplete v-model="cardData.saler" :fetch-suggestions="querySearchAsyncSaler" :placeholder="$t('input_56')"
										 @select="handleSelectSaler" value-key="name"></el-autocomplete>
									</div>
								</div>
								<div class="selectChoose">
									<div class="selectText">
										<p>{{$t('label_508')}}</p>
									</div>
									<div class="select">
										<el-input v-model="cardData.companyNumber" maxlength="20" :placeholder="$t('input_57')"></el-input>
									</div>
								</div>
							</div>
							<div class="selectBox" style="dispaly:gird"><!--v-if="version==1"-->

                <div class="selectChoose">
                  <div class="selectText" style="line-height: 20px">
                    <p>{{$t('label_520')}}</p>
                  </div>
                  <div class="select">
                    <el-autocomplete v-model="cardData.factoryUser" :fetch-suggestions="queryUser" :placeholder="$t('input_62')"
                                     @select="handleFactoryUser" value-key="fullName"></el-autocomplete>
                  </div>
                </div>
                <div class="selectChoose">
                  <div class="selectText" style="line-height: 20px">
                    <p>{{$t('label_525')}}</p>
                  </div>
                  <div class="select">
                    <el-autocomplete v-model="cardData.deputyUser" :fetch-suggestions="queryUser" :placeholder="$t('input_63')" @select="handleDeputyUser"
                                     value-key="fullName"></el-autocomplete>
                  </div>
                </div>

								<div class="selectChoose">
									<div class="selectText">
										<p>{{$t('label_423')}}(h)</p>
									</div>
									<div class="select">
										<el-input v-model="cardData.lifeTime" maxlength="8" :placeholder="$t('input_58') + '(h)'"></el-input>
									</div>
								</div>
								<div class="selectChoose">
									<div class="selectText">
										<p>{{$t('label_436')}}</p>
									</div>
									<div class="select">
										<!-- <el-input v-model="cardData.repair"></el-input>-->
										<el-autocomplete v-model="cardData.repair" :fetch-suggestions="querySearchAsyncRepair" :placeholder="$t('input_59')"
										 @select="handleSelectRepair" value-key="name"></el-autocomplete>
									</div>
								</div>
								<div class="selectChoose" style="height: 40px;">

								</div>
							</div>
<!--							<div class="selectBox" style="dispaly:gird" v-if="version!=1">-->
<!--								<div class="selectChoose">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('label_593')}}</p>-->
<!--									</div>-->
<!--									<div class="select">-->
<!--										<el-input v-model="cardData.equipmentName" :placeholder="$t('input_60')"></el-input>-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="selectChoose">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('label_194')}}</p>-->
<!--									</div>-->
<!--									<div class="select">-->
<!--										<el-input v-model="cardData.equipmentCode" :placeholder="$t('请输入设备编号')"></el-input>-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="selectChoose">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('label_672')}}</p>-->
<!--									</div>-->
<!--									<div class="select">-->
<!--										&lt;!&ndash; <el-input v-model="cardData.maker"></el-input> &ndash;&gt;-->
<!--										<el-autocomplete v-model="cardData.maker" :fetch-suggestions="querySearchAsyncMaker" :placeholder="$t('请输生产厂商')"-->
<!--										 @select="handleSelectMaker" value-key="name"></el-autocomplete>-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="selectChoose">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('销售厂商')}}</p>-->
<!--									</div>-->
<!--									<div class="select">-->
<!--										&lt;!&ndash; <el-input v-model="cardData.saler"></el-input> &ndash;&gt;-->
<!--										<el-autocomplete v-model="cardData.saler" :fetch-suggestions="querySearchAsyncSaler" :placeholder="$t('请输入销售厂商')"-->
<!--										 @select="handleSelectSaler" value-key="name"></el-autocomplete>-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="selectChoose">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('维修厂商')}}</p>-->
<!--									</div>-->
<!--									<div class="select">-->
<!--										&lt;!&ndash; <el-input v-model="cardData.repair"></el-input>&ndash;&gt;-->
<!--										<el-autocomplete v-model="cardData.repair" :fetch-suggestions="querySearchAsyncRepair" :placeholder="$t('input_59')"-->
<!--										 @select="handleSelectRepair" value-key="name"></el-autocomplete>-->
<!--									</div>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="selectBox" style="dispaly:gird" v-if="version!=1">-->
<!--								<div class="selectChoose">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('label_429')}}</p>-->
<!--									</div>-->
<!--									<div class="select">-->
<!--										&lt;!&ndash; <el-input v-model="cardData.equipmentTypeName"></el-input> &ndash;&gt;-->
<!--										<el-autocomplete v-model="cardData.equipmentTypeName" :fetch-suggestions="queryTypeName" :placeholder="$t('请选择设备类型')"-->
<!--										 @select="handleSelectType" value-key="name"></el-autocomplete>-->

<!--									</div>-->
<!--								</div>-->
<!--								<div class="selectChoose">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('label_161')}}</p>-->
<!--									</div>-->
<!--									<div class="select">-->
<!--										&lt;!&ndash; <el-input v-model="cardData.deptName"></el-input> &ndash;&gt;-->
<!--										&lt;!&ndash; <el-autocomplete v-model="cardData.deptName" :fetch-suggestions="queryDeptName" :placeholder="请选择所属区域" @select="handleSelectDept"-->
<!--										 value-key="name"></el-autocomplete> &ndash;&gt;-->
<!--										<el-tooltip class="item" effect="dark" :content="cardData.deptName" placement="top-start">-->
<!--											<el-select :value="cardData.deptName" clearable :placeholder="$t('input_65')" ref="selectTree1" :clearable="false">-->
<!--												<el-option :value="cardData.deptName" style="height: auto">-->
<!--													<el-tree :load="loadTree" @check-change="treeCheck" ref="tree" show-checkbox check-strictly lazy :props="treeProps"-->
<!--													 :accordion='true' node-key="id" :default-expanded-keys="deptIdList">-->
<!--														<div class="custom-tree-node" slot-scope="{node,data}">-->
<!--															<div class="title" style="width:250px;position:relative;display: flex">-->
<!--																<p style="width: 150px;display: block;overflow: hidden;line-height: 30px;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;">-->
<!--																	{{data.name}}-->
<!--																</p>-->
<!--															</div>-->
<!--														</div>-->
<!--													</el-tree>-->
<!--												</el-option>-->
<!--											</el-select>-->
<!--										</el-tooltip>-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="selectChoose">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('购入时间')}}</p>-->
<!--									</div>-->
<!--									<div class="select">-->
<!--										&lt;!&ndash; <el-input v-model="cardData.buyTime"></el-input> &ndash;&gt;-->
<!--										<el-date-picker type="date" value-format='yyyy-MM-dd' v-model="cardData.buyTime" :placeholder="$t('选择时间')"></el-date-picker>-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="selectChoose">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('label_481')}}</p>-->
<!--									</div>-->
<!--									<div class="select">-->
<!--										&lt;!&ndash; <el-input v-model="cardData.startUseTime"></el-input> &ndash;&gt;-->
<!--										<el-date-picker type="date" value-format='yyyy-MM-dd' v-model="cardData.startUseTime" :placeholder="$t('选择时间')"></el-date-picker>-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="selectChoose">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('使用寿命')}}</p>-->
<!--									</div>-->
<!--									<div class="select">-->
<!--										<el-input v-model="cardData.lifeTime" :placeholder="$t('请输入设备使用寿命') + '(h)'"></el-input>-->
<!--									</div>-->
<!--								</div>-->

<!--							</div>-->
<!--							<div class="selectBox" style="dispaly:gird" v-if="version!=1&&false">-->
<!--								<div class="selectChoose">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('label_520')}}</p>-->
<!--									</div>-->
<!--									<div class="select">-->
<!--										<el-autocomplete v-model="cardData.factoryUser" :fetch-suggestions="queryUser" :placeholder="$t('input_62')"-->
<!--										 @select="handleFactoryUser" value-key="fullName"></el-autocomplete>-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="selectChoose">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('label_525')}}</p>-->
<!--									</div>-->
<!--									<div class="select">-->
<!--										<el-autocomplete v-model="cardData.deputyUser" :fetch-suggestions="queryUser" :placeholder="$t('input_63')"-->
<!--										 @select="handleDeputyUser" value-key="fullName"></el-autocomplete>-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="selectChoose" style="height: 40px;">-->
<!--									<div class="selectText">-->
<!--										<p>{{$t('label_529')}}</p>-->
<!--									</div>-->
<!--									<div class="select" >-->
<!--										<el-input v-model="cardData.checkCode" :placeholder="$t('input_64')"></el-input>-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="selectChoose" style="height: 40px;">-->
<!--									&lt;!&ndash; <div class="selectText" v-if="version!=2">-->
<!--										<p>设备通讯编号</p>-->
<!--									</div>-->
<!--									<div class="select" v-if="version!=2">-->
<!--										<el-input v-model="cardData.deviceAddress" :placeholder="设备通讯编号"></el-input>-->
<!--									</div> &ndash;&gt;-->
<!--								</div>-->
<!--								<div class="selectChoose" style="height: 40px;">-->
<!--								</div>-->
<!--							</div>-->
							<div class="buttonBox">
								<div>
									<div class="chooseButton searchButton" style="margin: 10px 0;width:100px;background: #e7a026" v-if="cardData.useState=='1'&& MenuRoleList.indexOf('181')>=0"
									 @click="confrim">{{$t('btn_22')}}</div>
									<div class="chooseButton searchButton" style="margin: 10px 0;width:100px;background: #e7a026;cursor: not-allowed;"
									 v-else-if="cardData.useState=='1'">{{$t('btn_22')}}</div>
									<div class="chooseButton searchButton" style="margin: 10px 0;width:100px;cursor: not-allowed;" v-else-if="cardData.useState=='2'">{{$t('label_105')}}</div>
									<div class="chooseButton deleteButton" style="margin: 10px 0;width:100px;cursor: not-allowed;" v-else-if="cardData.useState=='3'">{{$t('btn_21')}}</div>

									<div class="chooseButton searchButton" style="margin: 10px 0;width:100px;" @click="cardData.operationState='2'"
									 v-if="cardData.operationState=='1'">{{$t('btn_23')}}</div>
									<div class="chooseButton deleteButton" style="margin: 10px 0;width:100px;" @click="cardData.operationState='1'"
									 v-if="cardData.operationState=='2'">{{$t('btn_24')}}</div>

									<div class="chooseButton searchButton" style="width:100px;margin-left: 0;cursor: not-allowed;background: #ffb400"
									 v-if="cardData.failureState=='2'">{{$t('label_408')}}</div>

									<div class="chooseButton searchButton" style="margin: 10px 0;width:100px;cursor: not-allowed;" v-if="cardData.lifeState=='1'">{{$t('label_426')}}</div>
									<div class="chooseButton searchButton" style="margin: 10px 0;width:100px;cursor: not-allowed;background: #ffb400"
									 v-if="cardData.lifeState=='2'">{{$t('label_442')}}</div>
									<div class="chooseButton deleteButton" style="margin: 10px 0;width:100px;cursor: not-allowed;" v-if="cardData.lifeState=='3'">{{$t('label_446')}}</div>
								</div>
							</div>
						</div>
						<div class="spotMes2Box" :style="{'height': 'calc(100% - 390px)'}">
							<div class="spotMesBox" style="height:100%;">
								<el-tabs v-model="activeNameSpot" @tab-click="handleClickSpot">
									<el-tab-pane :label="$t('label_335')" name="spot" v-if="MenuRoleList.indexOf('9')>=0">
										<div class="chooseBox chooseDevice">
											<div class="selectBox deviceSelectBox" style="width: 100%;height:400px;overflow: auto;display:block;">
												<template v-for="(item, i) in parameterData">
													<template v-if="item.type=='1'">
														<div class="selectChoose">
															<div class="selectText">
																<p>{{item.name}}:</p>
															</div>
															<div class="select">
																<el-select v-model="item.parameter" :placeholder="$t('input_65')">
																	<el-option v-for="item in item.defaultValue" :key="item.value" :label="item.value" :value="item.value">
																	</el-option>
																</el-select>
															</div>
														</div>
													</template>
													<template v-if="item.type=='2'">
														<div class="selectChoose">
															<div class="selectText">
																<p>{{item.name}}:</p>
															</div>
															<div class="select">
																<el-select multiple collapse-tags v-model="item.parameter" :placeholder="$t('input_65')" class="tags-select">
																	<el-option v-for="item in item.defaultValue" :key="item.value" :label="item.value" :value="item.value">
																	</el-option>
																</el-select>
															</div>
														</div>
													</template>
													<template v-if="item.type=='3'">
														<div class="selectChoose">
															<div class="selectText">
																<p>{{item.name}}:</p>
															</div>
															<div class="select">
																<el-input type="textarea" :rows="item.lineLimit" :maxlength="item.length" :placeholder="$t('input_46')" v-model="item.parameter">
																</el-input>
															</div>
														</div>
													</template>
													<template v-if="item.type=='4'">
														<div class="selectChoose">
															<div class="selectText">
																<p>{{item.name}}:</p>
															</div>
															<div class="select" style="display: flex">
																<el-input :placeholder="$t('input_46')" maxlength="50" v-model="item.parameter" @input="inputnum(item)">
																</el-input>
																<span style="line-height: 35px;margin-left: 10px;">{{item.unit}}</span>
															</div>
														</div>
													</template>
												</template>
											</div>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_533')" name="pro" v-if="MenuRoleList.indexOf('13')>=0">
										<div class="tabBbox" style="height: 405px">
											<checkItem ref="checkItemDisplay" :showButton="true" :needSort="true" :showPage="true" :fatherMethod="fatherMethod"></checkItem>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_483')" name="bao" v-if="MenuRoleList.indexOf('17')>=0">
										<div class="tabBbox" style="height: 405px">
											<maintenanceItem ref="maintenanceItemDisplay" :showButton="true" :needSort="true" :fatherMethod="fatherMethod"></maintenanceItem>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_143')" name="xun" v-if="MenuRoleList.indexOf('21')>=0">
										<div class="tabBbox" style="height: 405px">
											<inspectionItem ref="inspectionItemDisplay" :showButton="true" :needSort="true" :fatherMethod="fatherMethod"></inspectionItem>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_338')" name="txt" v-if="MenuRoleList.indexOf('25')>=0">
										<div class="tabBbox" style="height: 405px">
											<electronDocument ref="electronDocumentDisplay" :showButton="true" :needSort="true" :fatherMethod="fatherMethod"></electronDocument>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_119')" name="backup" v-if="MenuRoleList.indexOf('29')>=0">
										<div class="tabBbox" style="height: 405px">
											<partInfo ref="partInfoDisplay" :showButton="true" :needSort="true"></partInfo>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_340')" name="position" v-if="MenuRoleList.indexOf('208')>=0">
										<div class="tabMsss" style="height: 640px">
											<position ref="positionDisplay" :showButton="true" :needSort="true"></position>
										</div>
									</el-tab-pane>
								</el-tabs>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog v-loading="saveLoading" :title="$t('label_536')" class="prodialog" :visible.sync="progressShow" append-to-body :close-on-click-modal='false' width="500px"
		 top="20%" :before-close="handleClose2" custom-class="dialogBox">
			<div style="width: 100%;height: 100%;margin-bottom: 10px;">
				<el-progress :text-inside="true" :stroke-width="24" :percentage="progressList.percentage" status="success"></el-progress>
			</div>
			<div style="width: 100%;height:auto;">
				<p class="progressP">{{$t('label_538') + ':' +progressList.AllNum + $t('label_539') + ',' + $t('label_541') + ':' + progressList.num1 + $t('label_539')}}</p>
				<p class="progressP">{{$t('msg_7') + ':'+ progressList.listCode.join(",")}}</p>
				<p class="progressP">{{$t('msg_6') + ':' + progressList.listCode2.join(",")}}</p>
			</div>
		</el-dialog>
		<el-dialog :title="editEqumentName" :visible.sync="dialogEquDeviceAdd" append-to-body :close-on-click-modal='false'
		 width="400px" top="20%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogMes">
				<p>{{$t('label_297')}}</p>
				<div class="mesInput">
					<el-input v-model="newType.name"></el-input>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="newTypeSave">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import tree from "@/components/list/tree/tree";
	import file from "@/assets/js/file/file.js";
	import checkItem from "@/components/list/displayPage/checkItemParam";
	import maintenanceItem from "@/components/list/displayPage/maintenanceItemParam";
	import inspectionItem from "@/components/list/displayPage/inspectionItemParam";
	import electronDocument from "@/components/list/displayPage/electronDocumentParam";
	import partInfo from "@/components/list/displayPage/partInfoParam";
	import position from "@/components/list/displayPage/positionParam";
	import common from "@/assets/js/common/common.js";
	import organizationTabJs from "@/assets/js/system/organizationTab.js";

	export default {
		name: 'spotResumePage',
		components: {
			Page,
			calendar,
			tree,
			checkItem,
			maintenanceItem,
			inspectionItem,
			electronDocument,
			partInfo,
			position
		},
		data() {
			return {
        saveLoading: false,
				progressShow: false,
				treeProps: {
					label: 'name',
				},
				version: 2,
				visible: false,
				pageNum: 1,
				select: 0,
				pageSize: 10,
				pageCount: 0,
				Readytime: '',
				filterText: '',
				getTreeMes: '0',
				treeShow: true,
				MenuRoleList: [],
				newType: {
					name: '',
					operationState: '1',
					failureState: '1',
					lifeState: '1',
				},
				deviceDetailMes: {},
				tableChooseInfo: {},
				heightNum: '250',
				dialogDeviceSpot: false,
				dialogDeviceDetailMes: false,
				dialogEquDeviceAdd: false,
				editEqumentName: this.$t('label_460'),
				dialogDeviceBao: false,
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				checked: false,
				dialogSpotResult: false,
				dialogSpotTimeEdit: false,
				dialogSpotBatchTimeEdit: false,
				monthDOptions: [],
				cardData: [],
				tableDataDeviceList: [],
				parameterData: [],
				activeNameTree: 'second',
				activeNameSpot: 'spot',
				mainEditTree: 'project',
				activeNameDevice: 'device',
				searchDataList: {},
				equipmentStatusList: {

				},
				mainConfrimTree: 'main',
				formModel: {
					organizationId: '',
					roleName: "",
					duty: '',
					menuIds: [],
					menuNames: [],
					memberNames: [],
					memberIds: [],
					roleId: '',
				},
				deptIdList: ['0'],
				currentKeys: {},
				timers: null,
				progressList: {
					AllNum: 0,
					listCode: [],
					listCode2: [],
					num1: 0,
					numOK: 0,
					status: 0,
				},
				width: '340px',
				qrCodeShow: false,
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		methods: {
			handleInput(val) {
				console.log(val)
				// 去除所有非数字字符，再去除前导零
				this.cardData.deviceAddress = val.replace(/\D/g, '').replace(/^0+/, '') || ''
			},
			exportExcel() {
				window.open(this.$store.getters.getPostUrl + '/mes/equipmentInfo/download', "_blank")
			},
			importExcel(file1) {
				let types = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
				const isImage = types.includes(file1.file.type);
				if (!isImage) {
					this.$message({
						message: this.$t('msg_59') + '!',
						type: 'success'
					});
					return;
				}
				let that = this;
				var formData = new FormData();
				formData.append('file', file1.file);
				this.progressShow = true;
				this.timers = setInterval(() => {
					that.progress();
				}, 500)
				file.importExcel(formData).then((response) => {
					const data = response.data;
					if (data.code == 1) {

					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						// this.progressShow = false;
						clearInterval(this.timers);
						this.timers = null;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			progress() {
				let that = this;
				file.progress().then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.progressList = data.data;
						if(data.data.num1!=0){
							this.progressList.percentage=Number(data.data.numOK/data.data.num1).toFixed(1)
						}else{
							this.progressList.percentage=100
						}
						if(data.data.status==1){
							this.$message({
								message: this.$t('label_549'),
								type: 'success'
							});
							clearInterval(this.timers);
							this.timers = null;
							this.progressList.percentage=100
							that.clearProgress()
						}
					}
				}).catch((response) => {
					console.log(response)
				})
				// clearInterval(that.timers);
				// that.timers=null;
			},
			clearProgress() {
				file.delectProgress().then((response) => {
					const data = response.data;
					if (data.code == 1) {
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			inputnum(item) {
				if (item.type == '4') {
					let mes = '^(\\-)*(\\d+)\\.(';
					for (var i = 0; i < item.decimals; i++) {
						mes += '\\d'
					}
					mes = mes + ").*$";
					let knok = new RegExp(mes);
					let text = item.parameter.toString();
					if (text.split('.').length > 1) {
						if (text.split('.')[0].length > item.length) {
							utils.messageAlert(this.$t('msg_60'), this.$t('label_358'), this.$t('label_100'));
							item.parameter = Number(text.split('.')[0].substr(0, text.split('.')[0].length - 1) + '.' + text.split('.')[1])
						}
						if (text.split('.')[1].length > item.decimals) {
							utils.messageAlert(this.$t('msg_61'), this.$t('label_358'), this.$t('label_100'));
							item.parameter = item.parameter.replace(knok, '$1$2.$3');
						}
					} else {
						if (text.length > item.length) {
							item.parameter = Number(text.substr(0, text.length - 1));
						}
					}
				}
			},
			fatherMethod(val) {
				this.cardData.useState = val;
			},
			jump(data) {
				this.activeNameTree = 'first';
				this.$refs.treeDisplay.expand2(data, 0);
			},
			selectDeptIdList(id) {
				file.selectDeptIdList(id).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.deptIdList = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectDept(id) {
				file.selectDeptName(id).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.cardData.deptName = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			//从属于
			loadTree(node, resolve) {
				if (node.level === 0) {
					let child = this.getChildren(0);
					child.then((res) => {
						resolve(res);
					});
				} else {
					let child = this.getChildren(node.data.id);
					child.then((res) => {
						if (res == "") {
							return resolve([]);
						} else {
							resolve(res);
						}
					});
				}
			},
			async getChildren(pid) {
				let childArr = [];
				await organizationTabJs.getChildren({
					pid: pid
				}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						childArr = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
				return childArr;
			},
			treeCheck(data, checked, indeterminate) {
				if (checked) {
					this.formModel.organizationId = data.id;
					this.cardData.deptId = data.id;
					this.$refs.tree.setCheckedKeys([data.id], true)
					this.selectDept(data.id);
					this.$refs.selectTree1.blur()
				}

			},
			linkTree(type, eq) {
				this.deviceDetailMes = eq;
				if (type == 'first') { //类型
					this.$refs.treeDisplay.expand2(eq, 0);
					this.newType.equipmentTypeId = eq.equipmentTypeId;
					this.getTreeMes = '0';
					this.searchDataList = {
						deviceId: eq.equipmentTypeId,
						infoId: eq.id
					}
				} else { //区域
					this.$refs.treeDisplay2.expand2(eq, 1);
					this.newType.deptId = eq.deptId;
					this.getTreeMes = '0';
					this.searchDataList = {
						areaId: eq.deptId,
						infoId: eq.id
					}
				}
				setTimeout(() => {
					this.search();
				}, 500)
			},
			baocun() {
        console.log('是这个啊')
				let that = this;
				let type = this.activeNameTree;
				this.$confirm(this.$t('label_558') + '?', this.$t('label_358'), {
					confirmButtonText: this.$t('label_100'),
					cancelButtonText: this.$t('btn_1'),
					type: 'warning'
				}).then(() => {
					that.treeShow = false;
          let parameterDataText = JSON.parse(JSON.stringify(this.parameterData));
          console.log(this.parameterData)
          console.log(parameterDataText)
					for (var i = 0; i < parameterDataText.length; i++) {
						if (parameterDataText[i].required == 1) {
							//utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							if (parameterDataText[i].parameter == "" || parameterDataText[i].parameter == null || parameterDataText[i].parameter == undefined) {
								utils.messageAlert(parameterDataText[i].name + this.$t('label_562'), this.$t('label_358'), this.$t('label_100'));
								that.treeShow = true;
								return false;
							}
						}
						if (parameterDataText[i].type == "1" || parameterDataText[i].type == "2") {
              parameterDataText[i].defaultValue = JSON.stringify(parameterDataText[i].defaultValue);
              parameterDataText[i].parameter = JSON.stringify(parameterDataText[i].parameter);
						} else {

            }
					}
					file.saveEquipmentParameter(parameterDataText).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.cardData.name = this.cardData.equipmentName
							this.cardData.code = this.cardData.equipmentCode
							file.updateEquipmentInfo(this.cardData).then((response) => {
								const data = response.data;
								if (data.code == "1") {
									that.search();
									that.treeShow = true;
									this.$message({
										message: this.$t('msg_23'),
										type: 'success'
									});
									this.$nextTick(() => {
										this.linkTree(type, data.data);
									})
								} else {
									utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
								}
							}).catch((response) => {
								console.log(response)
							})
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
					}).catch((response) => {
						console.log(response)
					})
				}).catch(() => {

				});
			},
			baoFei() {
				let that = this;
				this.$confirm(this.$t('label_566') + '?', this.$t('label_358'), {
					confirmButtonText: this.$t('label_100'),
					cancelButtonText: this.$t('btn_1'),
					type: 'warning'
				}).then(() => {
					this.cardData.useState = '3';
					file.updateEquipmentInfo(this.cardData).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							that.search();
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
					}).catch((response) => {
						console.log(response)
					})
				}).catch(() => {

				});
			},
			upload(file1) {
				let types = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png'];
				const isImage = types.includes(file1.file.type);
				if (!isImage) {
					this.$message({
						message: this.$t('msg_62') + '!',
						type: 'success'
					});
					return;
				}
				var formData = new FormData();
				formData.append('file', file1.file);
				file.upload(formData).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.cardData.img = data.data
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			confrim() {
				let that = this;
				let type = this.activeNameTree;
				this.$confirm(this.$t('msg_63') + '?', this.$t('label_358'), {
					confirmButtonText: this.$t('label_100'),
					cancelButtonText: this.$t('btn_1'),
					type: 'warning'
				}).then(() => {
					for (var i = 0; i < this.parameterData.length; i++) {
						if (this.parameterData[i].required == 1) {
							if (this.parameterData[i].parameter == "" || this.parameterData[i].parameter == null || this.parameterData[i].parameter ==
								undefined) {
								utils.messageAlert(this.parameterData[i].name + this.$t('label_562'), this.$t('label_358'), this.$t('label_100'));
								return false;
							}
						}
						if (this.parameterData[i].type == "1" || this.parameterData[i].type == "2") {
							this.parameterData[i].defaultValue = JSON.stringify(this.parameterData[i].defaultValue);
							this.parameterData[i].parameter = JSON.stringify(this.parameterData[i].parameter);
						} else {}
					}
					const loading = that.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					that.treeShow = false;
					file.saveEquipmentParameter(this.parameterData).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.cardData.name = this.cardData.equipmentName
							this.cardData.code = this.cardData.equipmentCode

							file.updateEquipmentInfo(this.cardData).then((response) => {
								const data = response.data;
								if (data.code == "1") {
									let eeeq = data.data;
									file.confirmEquipmentInfo(this.deviceDetailMes.id).then((response) => {
										const data = response.data;
										if (data.code == "1") {
											that.treeShow = true;
											loading.close();
											this.$message({
												message: this.$t('msg_23'),
												type: 'success'
											});
											that.search();
											this.$nextTick(() => {
												this.linkTree(type, eeeq);
											})
										} else {

											loading.close();
											utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
										}
									}).catch((response) => {
										console.log(response)
									})
								} else {
									loading.close();
									utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
								}
							}).catch((response) => {
								console.log(response)
							})
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
					}).catch((response) => {
						console.log(response)
					})
				}).catch(() => {

				});
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			selectProp: function(index) {
				this.select = index
			},
			handler() {},
			handleClose() {
				this.dialogDeviceSpot = false;
				this.dialogSpotResult = false;
				this.dialogDeviceBao = false;
				this.dialogSpotBatchTimeEdit = false;
				this.dialogDeviceDetailMes = false;
				this.dialogEquDeviceAdd = false;
				this.progressShow = false;
				this.progressList= {
					AllNum: 0,
					listCode: [],
					listCode2: [],
					num1: 0,
					numOK: 0,
					status: 0,
				};
			},
			handleClose2() {
				this.progressShow = false;
				this.progressList= {
					AllNum: 0,
					listCode: [],
					listCode2: [],
					num1: 0,
					numOK: 0,
					status: 0,
				};
				this.treeShow = false;
				this.search();
				this.$nextTick(() => {
					this.treeShow = true;
				})
			},
			addEquipmentType() {
				this.dialogEquDeviceAdd = true;
				this.editEqumentName = this.$t('label_460');
			},
			editClick() {
				this.editEqumentName = this.$t('label_482');
				if (Object.keys(this.tableChooseInfo).length > 0) {
					this.newType.id = this.tableChooseInfo.id;
					this.newType.name = this.tableChooseInfo.name;
					this.dialogEquDeviceAdd = true;
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			newTypeSave() {
        this.saveLoading = true;
				if (this.newType.name == "") {
					utils.messageAlert(this.$t('msg_30'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return
				}
				this.treeShow = false;
				if (this.editEqumentName == this.$t('label_460')) {
					common.addEquipmentInfo(this.newType).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.search();
							this.dialogEquDeviceAdd = false;
							this.treeShow = true;
							this.newType = {
								name: '',
								equipmentTypeId: '',
								deptId: ''
							};
							this.$message({
								message: this.$t('msg_23'),
								type: 'success'
							});
						}
            this.saveLoading = false;
					}).catch((response) => {
            this.saveLoading = false;
						console.log(response)
					})
				} else {
					common.editEquipmentInfo(this.newType).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.search();
							this.dialogEquDeviceAdd = false;
							this.newType = {
								name: '',
								equipmentTypeId: '',
								deptId: ''
							};
							this.$message({
								message: this.$t('msg_23'),
								type: 'success'
							});
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				}
			},
			delEquipmentType() {
				let that = this;
				if (Object.keys(this.tableChooseInfo).length > 0) {
					let param = {
						id: this.tableChooseInfo.id
					};
					this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						this.treeShow = false;
						common.delEquipmentInfo(param).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								that.search();
								this.treeShow = true;
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}

			},
			moveUp(item, index) {
				this.tableDataTree.splice(index - 1, 0, item); // 定位到点击位置的上一行，0即不删除如何元素，在此位置插入item
				this.tableDataTree.splice(index + 1, 1); // 此时数组中有重复元素，把原来被挤下去的元素删除
			},
			// 下移
			moveDown(item, index) {
				this.tableDataTree.splice(index + 2, 0, item);
				this.tableDataTree.splice(index, 1);
			},
			moveUpDevice(item, index) {
				this.allDeviceData.splice(index - 1, 0, item); // 定位到点击位置的上一行，0即不删除如何元素，在此位置插入item
				this.allDeviceData.splice(index + 1, 1); // 此时数组中有重复元素，把原来被挤下去的元素删除
			},
			// 下移
			moveDownDevice(item, index) {
				this.allDeviceData.splice(index + 2, 0, item);
				this.allDeviceData.splice(index, 1);
			},
			// 控制下移按钮的显示于隐藏
			getFormLength(index) {
				if (index === this.tableDataTree.length - 1) return true;
				else return false;
			},
			getFormLengthDevice(index) {
				if (index === this.allDeviceData.length - 1) return true;
				else return false;
			},
			handleCurrentChangeAll(info) {},
			handleCurrentChangeDevice(info) {},
			selectCard(id) {
				file.selectCard(id).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.cardData = data.data;
						this.selectDept(data.data.deptId)
						if (this.cardData.autoFlag != null && this.cardData.autoFlag != '') {
							this.cardData.autoFlag = this.cardData.autoFlag.toString();
						}
						if (this.cardData.deptId != null && this.cardData.deptId != '') {

							this.selectDeptIdList(this.cardData.deptId)
							this.formModel.organizationIds = this.cardData.deptId
							this.$refs.tree.setCheckedKeys([this.cardData.deptId], true)
							this.$refs.checkItemDisplay.deptMes(this.cardData.deptId);
							this.$refs.maintenanceItemDisplay.deptMes(this.cardData.deptId);
							this.$refs.inspectionItemDisplay.deptMes(this.cardData.deptId);
							this.$refs.electronDocumentDisplay.deptMes(this.cardData.deptId);
						}

					}
				}).catch((response) => {
					console.log(response)
				})
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			queryUser(queryString, cb) {
				file.selectUser(queryString).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						cb(data.data)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			changeTime(value) {
				var arr = value;
				if (arr == null || arr == "") {
					return "-";
				} else {
					for (var i = 0; i < arr.length; i++) {
						if (arr[i].toString().length == 1) {
							arr[i] = "0" + arr[i];
						}
					}
					if (arr.length == 5) {
						var getFormatTime = arr[0] + "-" + arr[1] + "-" + arr[2] + "\t" + arr[3] + ":" + arr[4] + ":" + "00";
					} else {
						var getFormatTime = arr[0] + "-" + arr[1] + "-" + arr[2] + "\t" + arr[3] + ":" + arr[4] + ":" + arr[5];
					}
					return getFormatTime;
				}
			},
			handleFactoryUser(item) {
				this.cardData.factoryUser = item.fullName;
			},
			handleDeputyUser(item) {
				this.cardData.deputyUser = item.fullName;
			},
			getDeviceMes(data) {
				if (data.name == this.$t('label_272')) {
					this.getTreeMes = '0';
					this.searchDataList = {}
					this.deviceDetailMes = {}
					this.deviceDetailMes.name = this.$t('label_272')
					this.search();
					this.newType.equipmentTypeId = data.id;
				} else {
					this.deviceDetailMes = data;
					if (data.type == '1') {
						this.getTreeMes = '3';
						this.selectCard(data.id);
						this.getEquipmentParameter(data.id);
						this.$nextTick(() => {

							if (this.MenuRoleList.indexOf('13') >= 0) {
								this.$refs.checkItemDisplay.newMes(data.id);
							}
							if (this.MenuRoleList.indexOf('17') >= 0) {
								this.$refs.maintenanceItemDisplay.newMes(data.id);
							}
							if (this.MenuRoleList.indexOf('21') >= 0) {
								this.$refs.inspectionItemDisplay.newMes(data.id, 0);
							}
							if (this.MenuRoleList.indexOf('25') >= 0) {
								this.$refs.electronDocumentDisplay.newMes(data.id);
							}
							if (this.MenuRoleList.indexOf('29') >= 0) {
								this.$refs.partInfoDisplay.newMes(data.id);
							}
							if (this.MenuRoleList.indexOf('208') >= 0) {
								this.$refs.positionDisplay.newMes(data.id);
							}
							// this.$refs.checkItemDisplay.newMes(data.id);
							// this.$refs.maintenanceItemDisplay.newMes(data.id);
							// this.$refs.inspectionItemDisplay.newMes(data.id, 0);
							// this.$refs.electronDocumentDisplay.newMes(data.id);
							// this.$refs.partInfoDisplay.newMes(data.id);
							// this.$refs.positionDisplay.newMes(data.id);

							this.searchDeviceMesDetail();
						})
					} else if (data.type == '2') {
						this.newType.deptId = data.id;
						this.getTreeMes = '0';
						this.searchDataList = {
							areaId: data.id
						}
						this.search();
					} else if (data.type == '0') {
						this.newType.equipmentTypeId = data.id;
						this.getTreeMes = '0';
						this.searchDataList = {
							deviceId: data.id
						}
						this.search();
					}
				}
			},
			getDeviceMes2(data) {
				this.deviceDetailMes = data;
				if (this.activeNameTree == 'first') { //类型
					this.newType.equipmentTypeId = data.pid;
					this.getTreeMes = '0';
					this.searchDataList = {
						deviceId: data.pid,
						infoId: data.id
					}
					this.search();
				} else { //区域
					this.newType.deptId = data.pid;
					this.getTreeMes = '0';
					this.searchDataList = {
						areaId: data.pid,
						infoId: data.id
					}
					this.search();
				}
			},
			showDeviceMes(data) {
				this.$refs.treeDisplay.showCard(data.id);
				/*this.getTreeMes = '3';
				this.selectCard(data.id);
				this.getEquipmentParameter(data.id);
				this.$nextTick(() => {
					this.$refs.checkItemDisplay.newMes(data.id);
					this.$refs.maintenanceItemDisplay.newMes(data.id);
					this.$refs.inspectionItemDisplay.newMes(data.id, 0);
					this.$refs.electronDocumentDisplay.newMes(data.id);
					this.$refs.partInfoDisplay.newMes(data.id);
					this.searchDeviceMesDetail();
				})*/
			},
			searchDeviceMesDetail() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				if (this.MenuRoleList.indexOf('13') >= 0) {
					this.$refs.checkItemDisplay.searchPage({
						pageNum: 1,
						pageSize: 50,
					});
				}
				if (this.MenuRoleList.indexOf('17') >= 0) {
					this.$refs.maintenanceItemDisplay.searchPage({
						pageNum: 1,
						pageSize: 50,
					});
				}
				if (this.MenuRoleList.indexOf('21') >= 0) {
					this.$refs.inspectionItemDisplay.searchPage(param);
				}
				if (this.MenuRoleList.indexOf('25') >= 0) {
					this.$refs.electronDocumentDisplay.searchPage(param);
				}
				if (this.MenuRoleList.indexOf('29') >= 0) {
					this.$refs.partInfoDisplay.searchPage(param);
				}
				if (this.MenuRoleList.indexOf('208') >= 0) {
					this.$refs.positionDisplay.searchPage(param);
				}
				// this.$refs.checkItemDisplay.searchPage(param);
				// this.$refs.maintenanceItemDisplay.searchPage(param);
				// this.$refs.inspectionItemDisplay.searchPage(param);
				// this.$refs.electronDocumentDisplay.searchPage(param);
				// this.$refs.partInfoDisplay.searchPage(param);
				// this.$refs.positionDisplay.searchPage(param);
			},
			tableDataTreeInfoEdit() {
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.dialogDeviceSpot = true;
					this.tableDataTreeEdit = this.tableDataTreeInfo
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			getEquipmentParameter(param) {
				file.getEquipmentParameter(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.parameterData = data.data;
						// console.log(this.parameterData)
						for (var i = 0; i < data.data.length; i++) {
							if (this.parameterData[i].type == 1) {
								this.parameterData[i].defaultValue = JSON.parse(this.parameterData[i].defaultValue)
								if (this.parameterData[i].parameter == null || this.parameterData[i].parameter == '') {
									this.parameterData[i].parameter = this.parameterData[i].defaultValue[0].value;
								} else {
									this.parameterData[i].parameter = this.parameterData[i].parameter.substring(1, this.parameterData[i].parameter
										.length - 1)
								}

							} else if (this.parameterData[i].type == 2) {
								this.parameterData[i].defaultValue = JSON.parse(this.parameterData[i].defaultValue)
								if (this.parameterData[i].parameter != null && this.parameterData[i].parameter != '') {
									this.parameterData[i].parameter = JSON.parse(this.parameterData[i].parameter);
								}
							}
						}
						// console.log(this.parameterData.defaultValue)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			handleCurrentChangeTreeTime(info) {
				this.tableChooseInfo = info;
			},
			handleClickTree(tab, event) {
				/*if (tab.label == '区域') {
				  this.getTreeMes = '0';
				} else {

				}*/
				this.getTreeMes = '0';
				this.searchDataList = {}
				this.deviceDetailMes = {}
				this.deviceDetailMes.name = this.$t('label_272')
				this.search()
			},
			handleClickSpot(tab, event) {

			},
			handleClickDevice(tab, event) {
				//console.log(tab, event);
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param);
			},
			searchPage(param) {
				var dataParam = this.searchDataList;
				var newParam = Object.assign(param, dataParam);
				this.getEquipmentInfoPageList(newParam)
				this.getEquipmentInfoPageStatusList(newParam)
			},
			getEquipmentInfoPageList(newParam) {
				file.getEquipmentInfoPageList(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataDeviceList = data.data.records;
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getEquipmentInfoPageStatusList(newParam) {
				file.getEquipmentInfoPageStatusList(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.equipmentStatusList = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			querySearchAsyncMaker(queryString, cb) {
				let param = {
					name: queryString,
					type: '2',
				}
				file.selectEquipmentFirmList(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						cb(data.data)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			querySearchAsyncSaler(queryString, cb) {
				let param = {
					name: queryString,
					type: '1',
				}
				file.selectEquipmentFirmList(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						cb(data.data)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			querySearchAsyncRepair(queryString, cb) {
				let param = {
					name: queryString,
					type: '3',
				}
				file.selectEquipmentFirmList(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						cb(data.data)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			queryDeptName(queryString, cb) {
				let param = {}
				if (queryString == undefined) {
					param = {
						name: ''
					}
				} else {
					param = {
						name: queryString
					}
				}
				file.selectDeptListByName(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						cb(data.data)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			handleSelectMaker(item) {
				this.cardData.maker = item.name;
			},
			handleSelectRepair(item) {
				this.cardData.repair = item.name;
			},
			handleSelectSaler(item) {
				this.cardData.saler = item.name;
			},
			handleSelectDept(item) {
				this.cardData.deptName = item.name;
				this.cardData.deptId = item.id;
			},
			handleSelectType(item) {
				this.cardData.equipmentTypeName = item.name;
				this.cardData.equipmentTypeId = item.id;
			},
			queryTypeName(queryString, cb) {
				let param = {}
				if (queryString == undefined) {
					param = {
						name: ''
					}
				} else {
					param = {
						name: queryString
					}
				}
				file.selectTypeListByName(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						cb(data.data)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
				} else {
					this.width = "340px";
				}
			},
		},

		beforeDestroy() {
			clearInterval(this.timers);
			this.timers = null;
		},
		created() {
			this.MenuRoleList = this.$store.getters.getMenu;
			this.version = this.$store.getters.getVersions;
		}
	}
</script>

<style>
.progressP{
	font-size: 15px;
}
.right-showbtn-qrcode-background {
	/* position: absolute; */
	width: 10px;
	height: 80px;
	background-color: #9c9c9c;
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
	margin: auto;
}

.right-showbtn {
	width: 10px;
	height: 100%;
	display: flex;
	position: relative;
	z-index: 100000;
}

.el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}


</style>



// WEBPACK FOOTER //
// src/pages/file/deviceFilePage.vue